import { useSelector } from 'react-redux';
import { Spacer } from '@vinted/web-ui';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { MEMBER_FOLLOWERS_URL, MEMBER_FOLLOWING_URL, MEMBER_FOLLOW_URL } from 'constants/routes';
import { UserTabType } from 'constants/follow';
import { AbTestVariant } from 'constants/index';
import { Screen } from 'constants/tracking/screens';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent } from 'libs/common/event-tracker/events';
import useTracking from 'hooks/useTracking';
import useAbTest from 'hooks/useAbTest/useAbTest';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FollowType;

(function (FollowType) {
  FollowType["Following"] = "Following";
  FollowType["Followers"] = "Followers";
})(FollowType || (FollowType = {}));

const FollowInfo = _ref => {
  var _useAbTest;

  let {
    followersCount,
    followingCount,
    userId,
    viewingSelf
  } = _ref;
  const translate = useTranslate('user');
  const isUserFollowFeatureEnabled = useSelector(getIsFeatureSwitchEnabled('next_page_user_follow'));
  const isFollowingPageReworkAbTestEnabled = ((_useAbTest = useAbTest({
    abTestName: 'following_page_rework'
  })) === null || _useAbTest === void 0 ? void 0 : _useAbTest.variant) === AbTestVariant.On;
  const {
    track
  } = useTracking();

  const followersURL = id => {
    if (isUserFollowFeatureEnabled && isFollowingPageReworkAbTestEnabled) {
      return MEMBER_FOLLOW_URL(id, UserTabType.Followers);
    }

    return MEMBER_FOLLOWERS_URL(id);
  };

  const followingURL = id => {
    if (isUserFollowFeatureEnabled && isFollowingPageReworkAbTestEnabled) {
      return MEMBER_FOLLOW_URL(id, UserTabType.Following);
    }

    return MEMBER_FOLLOWING_URL(id);
  };

  const handleFollowClick = type => {
    if (viewingSelf) track(clickEvent({
      screen: Screen.CurrentUserProfile,
      target: ClickableElement[type]
    }));
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "u-flexbox u-flex-wrap",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "u-flexbox",
      children: [/*#__PURE__*/_jsx("a", {
        href: followersURL(userId),
        onClick: () => handleFollowClick(FollowType.Followers),
        children: followersCount
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      }), translate('followers', undefined, {
        count: followersCount
      }), /*#__PURE__*/_jsx("span", {
        children: ","
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "u-flexbox",
      children: [/*#__PURE__*/_jsx("a", {
        href: followingURL(userId),
        onClick: () => handleFollowClick(FollowType.Following),
        children: followingCount
      }), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      }), translate('following', undefined, {
        count: followingCount
      })]
    })]
  });
};

export default FollowInfo;